
import {
    defineAsyncComponent, ref, defineComponent, PropType
} from 'vue';
import { GetSignedPolicyInfoByPrivacyPolicy } from '@/api/common/privacyPolicy';
import UcloudAnnexPolicy from '../../ucloud-annex-policy.vue';

export default defineComponent({
    props: {
        formData: {
            type: Object as PropType<GetSignedPolicyInfoByPrivacyPolicy>,
            default: () => ({})
        }
    },
    components: {
        UcloudAnnexPolicy
    }
});

